import FAQ from "../components/views/users/home/Faq";
import GetStarted from "../components/views/users/home/GetStarted";
import PricingComponent from "../components/views/users/pricing/PriceSection";

const Pricing = () => {
  return (
    <div>
      <PricingComponent />
      <FAQ />
      <GetStarted />
    </div>
  );
};

export default Pricing;
